import { useRef } from 'react'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import { generateId } from 'utilities/uniqueId'

type Props = {
  disabled: boolean
  tooltip: string
  placement?: 'top' | 'right' | 'bottom' | 'left'
  children: React.ReactNode
}

export const TooltipWhenDisabled = ({
  disabled,
  tooltip,
  placement = 'bottom',
  children,
}: Props) => {
  const tooltipId = useRef(`disabled-tooltip-${generateId()}`).current

  if (!disabled) return <>{children}</>

  return (
    <OverlayTrigger
      placement={placement}
      overlay={<Tooltip id={tooltipId}>{tooltip}</Tooltip>}
    >
      <span className="d-inline-block" tabIndex={0} aria-label={tooltip}>
        {children}
      </span>
    </OverlayTrigger>
  )
}
